import { render } from "./ProductsCommandRail.vue?vue&type=template&id=163181a8&scoped=true"
import script from "./ProductsCommandRail.vue?vue&type=script&lang=js"
export * from "./ProductsCommandRail.vue?vue&type=script&lang=js"

import "./ProductsCommandRail.vue?vue&type=style&index=0&id=163181a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163181a8"]])

export default __exports__